module.exports = __webpack_public_path__ + "static/media/content-12.e70bbb13.svg";